import { render, staticRenderFns } from "./AddEditBadge.vue?vue&type=template&id=10032dcb"
import script from "./AddEditBadge.vue?vue&type=script&lang=js"
export * from "./AddEditBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports